
import { Vue, Options } from "vue-property-decorator";
@Options({
  name: "limits",
})
export default class Limits extends Vue {}
